// The base route is the home screen. Only an explicit conversation intent opens chat.
export const isChatRoute = search => {
  const params = new URLSearchParams(search);
  return ['conversation', 'project', 'new'].some(key => !!params.get(key));
};
